import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { withStyles } from 'tss-react/mui';
import AdminTable from '../../../common/components/table/AdminTable';
import ApiService from '../../../common/services/ApiService';
import MetadataService from '../../../common/services/MetadataService';
import VcmFilters from './VcmFilters';
import { vcmStatusOptions } from './options';

const styles = (theme) => ({
  exportHeader: {
    padding: `${theme.typography.pxToRem(22)} ${theme.typography.pxToRem(
      25
    )} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)}`
  },
  vcmsListHeadline: {
    marginTop: theme.typography.pxToRem(8),
    marginBottom: theme.typography.pxToRem(35)
  }
});

export class BoldText extends React.Component {
  render() {
    const { attribute, row } = this.props;
    const value = row[attribute];
    return (
      <Typography
        sx={{
          fontSize: (theme) => theme.typography.pxToRem(13),
          fontWeight: 700,
          whiteSpace: 'nowrap'
        }}
      >
        {value}
      </Typography>
    );
  }
}

class VcmList extends React.Component {
  constructor(props) {
    super(props);
    this.api = new ApiService();
    this.meta = new MetadataService();
    this.metadata = {
      ...this.meta.get('vcms'),
      revision_text: {
        type: 'component',
        component: BoldText,
        label: 'Revision',
        componentProps: {
          attribute: 'revision_text',
          classes: {}
        },
        sortable: true,
        sortKey: 'year'
      }
    };
    this.fields = props.institute.vocational_currency_uses_units
      ? [
          'revision_text',
          'owner_user.full_name',
          'created_at',
          'approved_at',
          'current_units_text',
          'status',
          'approver_user.full_name'
        ]
      : [
          'revision_text',
          'owner_user.full_name',
          'created_at',
          'approved_at',
          'status',
          'approver_user.full_name'
        ];
    this.state = {
      filters: { status_eq: 'in_review' },
      params: {},
      order: null,
      orderBy: null,
      filterOptionsFetched: false
    };
  }

  handleFilterOptionsFetched = () => {
    this.setState({ filterOptionsFetched: true });
  };

  handleApplyFilters = (filters, params) => {
    this.setState({ filters, params });
  };

  handleApplySorting = (order, orderBy) => {
    this.setState({ order: order, orderBy: orderBy });
  };

  handleExport = () => {
    const sortingParams = {
      direction: this.state.order,
      field: this.state.orderBy
    };

    return this.api.fullUrl(
      '/api/v1/vcms.csv',
      this.state.filters,
      null,
      null,
      sortingParams,
      null
    );
  };

  handleOnUserCellClicked = (row) => {
    this.props.navigate('/users/' + row.owner_user.id);
  };

  handleOnRevisionCellClicked = (row) => {
    this.props.navigate('/vcm/' + row.id);
  };

  render() {
    const {
      classes,
      institute: { vocational_currency_uses_units }
    } = this.props;
    const { filters, filterOptionsFetched, params } = this.state;

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <Typography className={classes.vcmsListHeadline} variant="h5">
            Manage VCMs
          </Typography>
          <Paper>
            <VcmFilters
              onOptionsFetched={this.handleFilterOptionsFetched}
              handleApplyFilters={this.handleApplyFilters}
              vcmStatusOptions={vcmStatusOptions}
              showCurrencyFilters={vocational_currency_uses_units}
            />
          </Paper>
        </Grid>
        <Grid size={12}>
          <Paper>
            <Grid
              container
              className={classes.exportHeader}
              justifyContent="space-between"
            >
              <Typography variant="h6">VCMs</Typography>
              <a href={`${this.handleExport()}`} target="_blank">
                <Button color="secondary" size="small" variant="contained">
                  <Typography variant="button">Export</Typography>
                </Button>
              </a>
            </Grid>
            {filterOptionsFetched ? (
              <AdminTable
                showTablePagination
                fields={this.fields}
                metadata={this.metadata}
                filters={filters}
                params={params}
                handleApplySorting={this.handleApplySorting}
                onCellClicked={{
                  ['owner_user.full_name']: this.handleOnUserCellClicked,
                  ['revision_text']: this.handleOnRevisionCellClicked
                }}
                resource="vcms"
              />
            ) : null}
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

function VcmListWrapper(props) {
  const navigate = useNavigate();
  return <VcmList {...props} navigate={navigate} />;
}

export default withStyles(VcmListWrapper, styles, { withTheme: true });
